import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { clmApiClient } from '../clients';
import type { PatientCreateRequest, PatientCreateResponse } from '../types';

const patientCreateMutation = async (
  data: PatientCreateRequest,
): Promise<PatientCreateResponse> => {
  const response = await clmApiClient.post('patient', data);

  if (!response.ok || !response.data) {
    throw new Error(response.problem ?? 'Error creating patient');
  }

  return response.data as PatientCreateResponse;
};

export const usePatientCreateMutation = (
  config?: Omit<
    UseMutationOptions<PatientCreateResponse, Error, PatientCreateRequest>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation({
    mutationKey: ['patient-create'],
    mutationFn: patientCreateMutation,
    ...config,
  });
